export default "__VITE_ASSET__BraST3Hn__"